import { Properties } from 'types';

export const defaultFilters: Properties = {
  page: 1,
  page_size: 12,
};
